export default {
  formId: "checkoutForm",
  formField: {
    desiredDate: {
      name: "desiredDate",
      label: "Date*",
      requiredErrorMsg: "Date is required",
    },
    desiredTime: {
      name: "desiredTime",
      label: "Time*",
      requiredErrorMsg: "Time is required",
    },
    firstName: {
      name: "firstName",
      label: "First name*",
      requiredErrorMsg: "First name is required",
    },
    lastName: {
      name: "lastName",
      label: "Last name*",
      requiredErrorMsg: "Last name is required",
    },
    email: {
      name: "email",
      label: "Email*",
      requiredErrorMsg: "Email is required",
      invalidErrorMsg: "email should match example@domain.com",
    },
    phoneNumber: {
      name: "phoneNumber",
      label: "Phone Number*",
      requiredErrorMsg: "phoneNumber is required",
      invalidErrorMsg: "enter valid phone mumber",
    },
    type1: {
      name: "type1",
      label: "type1*",
    },
    type2: {
      name: "type2",
      label: "type2*",
    },
    type3: {
      name: "type3",
      label: "type3*",
    },
    checkresident: {
      name: "checkresident",
      label: "Checkresident,",
    },
    nameOnCard: {
      name: "nameOnCard",
      label: "Name on card*",
      requiredErrorMsg: "Name on card is required",
    },
    cardNumber: {
      name: "cardNumber",
      label: "Card number*",
      requiredErrorMsg: "Card number is required",
      invalidErrorMsg: "Card number is not valid (e.g. 4111111111111)",
    },
    expiryDate: {
      name: "expiryDate",
      label: "Expiry date*",
      requiredErrorMsg: "Expiry date is required",
      invalidErrorMsg: "Expiry date is not valid",
    },
    cvv: {
      name: "cvv",
      label: "CVV*",
      requiredErrorMsg: "CVV is required",
      invalidErrorMsg: "CVV is invalid (e.g. 357)",
    },
  },
};
